module.exports = __webpack_public_path__ + "media/src/images/icon__sad--5--dark-7141bb7393e97f69dd1e10e22148dbd3.png";